import React, { useEffect, useState } from 'react';
import AuthAxios from '../../axios';
import { toast } from 'react-toastify';

interface GuestInquiryModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function GuestInquiryModal({ isOpen, setIsOpen }: GuestInquiryModalProps) {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    setIsFormValid(isValidEmail && Boolean(phone && title && content));
  }, [email, phone, title, content]);

  if (!isOpen) return null;
  const onClose = () => {
    setEmail('');
    setPhone('');
    setTitle('');
    setContent('');
    setIsOpen(false);
  };
  const handleSubmit = async () => {
    const formData = { email, phone, title, content };
    if (!isFormValid) {
      toast.error('모든 항목을 올바르게 입력해주세요.');
      return;
    }
    try {
      await AuthAxios.post('/inquiry/guest', formData);
      toast.success('문의가 정상적으로 접수되었습니다.');
      onClose();
    } catch (err) {
      toast.error('문의 전송에 실패했습니다. 다시 시도해주세요.');
      console.error(' handleSubmit ~ err:', err);
    }
  };

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
        <div className="bg-white rounded-lg p-6 w-[90%] max-w-md">
          <h2 className="text-lg font-semibold mb-4">문의하기</h2>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">이메일</label>
            <input
              type="email"
              placeholder="이메일을 입력해주세요"
              className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">전화번호</label>
            <input
              type="text"
              placeholder="전화번호(숫자만)를 입력해주세요"
              className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
              value={phone}
              onChange={(e) => {
                const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                setPhone(onlyNumbers);
              }}
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">문의제목</label>
            <input
              type="text"
              placeholder="제목을 입력해주세요"
              className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">문의내용</label>
            <textarea
              placeholder="내용을 입력해주세요."
              className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm h-24"
              value={content}
              onChange={(e) => setContent(e.target.value)}
            ></textarea>
          </div>
          <div className="flex justify-end gap-2">
            <button className="bg-gray-200 text-sm px-4 py-2 rounded-md" onClick={onClose}>
              닫기
            </button>
            <button
              className={`${isFormValid ? 'bg-blue-500 text-white' : 'bg-gray-50 text-gray-400'}  text-sm px-4 py-2 rounded-md`}
              onClick={handleSubmit}
            >
              제출하기
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
